export default class HttpError extends Error {
  constructor(errors: string[]) {
    super();
    this.name = "HttpError";
    this.errors = errors;
  }

  errors: string[];
}
